/**
 * Where Reports lands when it is opened without a report id (#6707).
 *
 * The list draws the living Strategy Report row first and the dated reports
 * after it, so the landing follows the list: whatever it would draw first.
 * The Strategy Report comes from its own pipeline (strategy_doc runs), not
 * the report-generation one, which is why the index once missed it and
 * landed on 'none' beside a list with a report in it.
 */
export type ReportsLandingInput = {
  /** The dated reports in list order. */
  reportIds: number[];
  /** A report-generation task is running and nothing dated has landed yet. */
  hasInProgress: boolean;
  /** The living Strategy Report, or its run in flight, would be drawn. */
  hasStrategyRow: boolean;
};

export function landingReportId({ reportIds, hasInProgress, hasStrategyRow }: ReportsLandingInput): string {
  if (hasStrategyRow) return 'strategy';
  if (reportIds.length > 0) return String(reportIds[0]);
  if (hasInProgress) return 'generating';
  return 'none';
}
